// extracted by mini-css-extract-plugin
export var active = "_c6-2";
export var recordingDot = "_c6-1";
export var recordingIndicator = "_c6-0";